/**
 * Iniciais de exibição (2 letras) a partir do nome do usuário.
 * Usa primeira letra do primeiro token + primeira do último token quando houver sobrenome.
 */
export const getDisplayInitials = (name: string): string => {
  const parts = name.trim().split(/\s+/).filter(Boolean)
  if (parts.length === 0) return '??'
  if (parts.length === 1) {
    const word = parts[0]
    return word.slice(0, 2).toUpperCase()
  }
  const first = parts[0][0] ?? ''
  const last = parts[parts.length - 1][0] ?? ''
  return `${first}${last}`.toUpperCase()
}
